import script from "./MallNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./MallNavigation.vue?vue&type=script&setup=true&lang=js"

import "./MallNavigation.vue?vue&type=style&index=0&id=5a1e8b62&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1e8b62"]])

export default __exports__